<template>
  <div class="" id="Explain">
    <!-- <mt-header fixed title="说明">
        <router-link to="/" slot="left">
            <mt-button icon="back"></mt-button>
        </router-link>
    </mt-header> -->
    <!-- <div class="line-59"></div> -->
    <div class="what">
        <div class="what-box">
            <div class="img">
                <img src="static/image/img@2x.png" alt="">
            </div>
            <div class="title">
                <h1>什么是马力</h1>
                <span>马力是联联车推出的用户贡献值</span>
                <em>目前10马力=1元人民币</em>
            </div>
        </div>
        <div class="clearfix"></div>
    </div>
    <div class="what">
        <div class="what-box">
            <div class="img">
                <img src="static/image/img@2x.png" alt="">
            </div>
            <div class="title">
                <h1>如何得到马力</h1>
                <span>通过平台多种方式可以产出马力</span>
            </div>
        </div>
        <div class="clearfix"></div>
    </div>
    <div class="what">
        <div class="what-box">
            <div class="img">
                <img src="static/image/img@2x.png" alt="">
            </div>
            <div class="title">
                <h1>马力的作用</h1>
                <span>1.马力50%可兑换商品（3000多款平价正品）</span>
                <span>2.马力50%可兑换车币（10个马力兑换1枚车币）</span>
            </div>
        </div>
        <div class="clearfix"></div>
    </div>
    <div class="what">
        <div class="what-box">
            <div class="img">
                <img src="static/image/img@2x.png" alt="">
            </div>
            <div class="title">
                <h1>车币的价值</h1>
                <em>目前1枚车币=1人民币</em>
                <span>1.车币可转出到银行（平台回收）</span>
                <span>2.车币可增值（5000枚车币为1份增值权，按月分配）</span>
                <span>*仅前2000份金牌车达人有增值权益，每人最高3份增值权</span>
            </div>
        </div>
        <div class="clearfix"></div>
    </div>
    <div class="what">
        <div class="what-box">
            <div class="img">
                <img src="static/image/img@2x.png" alt="">
            </div>
            <div class="title">
                <h1>用户奖励与权益</h1>
                <em>一．普通用户</em>
                <span>1.邀请产生：邀请好友注册产10马力，被注册的好友产20马力</span>
                <br>
                <em>二．车达人</em>
                <span>1.邀请产生：邀请普通用户注册10马力，邀请车达人注册800马力</span>
                <span>2.浏览产生：朋友圈点击浏览每次可得3马力，举例一天100人点击你就有30块收入</span>
                <span>3.自购产生：买车约20000马力，卖车固定5000马力</span>
                <span>4.销售产生：买车订单可产约20000马力，卖车订单固定5000马力</span>
                <span>5.平级销售产生：队友成为了车达人身份，每个订单固定产1000马力</span>
            </div>
        </div>
        <div class="clearfix"></div>
    </div>
  </div>
</template>

<script>
import {
  Swipe,
  SwipeItem,
  Header,
  Cell,
  DatetimePicker
} from 'mint-ui';
import Vue from "vue";
Vue.component(Header.name,Header);
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);
Vue.component(Cell.name, Cell);
Vue.component(DatetimePicker.name, DatetimePicker);
export default {
  name: 'Explain',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  loadMore() {
  this.loading = true;
  setTimeout(() => {
    let last = this.list[this.list.length - 1];
    for (let i = 1; i <= 10; i++) {
      this.list.push(last + i);
    }
    this.loading = false;
  }, 2500);
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mint-header-button > a{
    color: #2c2c2c;
}
html{
    background-color: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/components/Explain.vue